import { ReactNode } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ContentContainer } from '@/components/ui/content-container.component';

interface SearchSuggestionsProps {
  children: ReactNode;
  hasResults: boolean;
}

export function SearchSuggestions({ children, hasResults }: SearchSuggestionsProps) {
  return (
    <section
      data-testid={DataTestIdEnum.SEARCH_PAGE_SUGGESTIONS_SECTION}
      className="flex w-full flex-col items-center bg-green-100 py-10"
    >
      <ContentContainer className="md:px-0 md:mx-auto md:max-w-[576px] lg:max-w-3xl flex flex-col gap-6">
        <div className="flex w-full flex-col gap-2">
          <h2 className="text-2xl font-bold leading-8 text-gray-900">
            {hasResults ? 'Não encontrou o que procurava?' : 'Confira as opções disponíveis para você'}
          </h2>
          {hasResults && (
            <p className="text-lg leading-6 text-gray-700">Temos outras opções para você!</p>
          )}
        </div>
        {children}
      </ContentContainer>
    </section>
  );
}
